import {Phone, Video} from 'lucide-react';
import {useIntl} from 'react-intl';
import type {RoomCallSummary} from '@phonehq/rtc-core';
import {useRoomCallSummary} from '../hooks/useGroupCall';
import {groupCallMessages as m} from '../messages';
import {countCallPeople} from '../services/callPeople';

export const CallInProgressPill = ({summary, compact = false}: {summary: RoomCallSummary; compact?: boolean}) => {
    const intl = useIntl();
    const Icon = summary.intent === 'video' ? Video : Phone;
    const people = countCallPeople(summary.userIds);
    const label = intl.formatMessage(m.callInProgress, {count: people});
    return (
        <span
            data-testid="call-in-progress-badge"
            title={label}
            className={`${compact ? '' : 'ml-3 mr-3'} inline-flex shrink-0 items-center gap-1 rounded-full bg-emerald-50 px-2 py-0.5 text-[11px] font-medium text-emerald-700 ring-1 ring-emerald-200 ${summary.includesMe ? 'bg-emerald-100' : ''}`}
        >
            <span className="relative flex h-2 w-2" aria-hidden="true">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75"/>
                <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-500"/>
            </span>
            <Icon size={12} aria-hidden="true"/>
            {compact ? <span>{people}</span> : (
                <>
                    <span data-testid="call-in-progress-label" className="max-[899px]:sr-only">{label}</span>
                    <span aria-hidden="true" className="min-[900px]:hidden">{people}</span>
                </>
            )}
        </span>
    );
};

export const CallInProgressBadge = ({roomId, compact = false}: {roomId: string | null | undefined; compact?: boolean}) => {
    const summary = useRoomCallSummary(roomId);
    if (!summary || summary.participantCount === 0) {
        return null;
    }
    return <CallInProgressPill summary={summary} compact={compact}/>;
};
